var map = {
	"./hide.png": "0c9b",
	"./menu-account-active.png": "7b38",
	"./menu-account.png": "9f67",
	"./menu-client-active.png": "f868",
	"./menu-client.png": "0cb6",
	"./menu-home-active.png": "7aca",
	"./menu-home.png": "9c97",
	"./menu-market-active.png": "e78c",
	"./menu-market.png": "9967",
	"./menu-purchase-active.png": "ecc7",
	"./menu-purchase.png": "3da0",
	"./menu-sale-active.png": "ef5d",
	"./menu-sale.png": "288f",
	"./menu-stock-active.png": "2385",
	"./menu-stock.png": "e0e1",
	"./menu-supplier-active.png": "d181",
	"./menu-supplier.png": "b3db",
	"./menu-system-active.png": "3534",
	"./menu-system.png": "b8d0",
	"./set.png": "2b61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7f9";